import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import store from '../store'
import {getToken} from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  // baseURL: "", // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (getToken()) {
    config.headers['Token'] = getToken() // 让每个请求携带自定义token
  }
  return config
}, error => {
  console.log(error);
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      //不在登录界面并且被登出
      if (location.href.indexOf('/login') === -1 && (res.code == 10001 || res.code == 10002)) {
        if(getToken()){//有被登出就清掉本地登录信息，同时多个异步请求时，以下代码也只执行一次
          // Message({
          //   message: "您已被登出，请重新登陆",
          //   type: 'error',
          // })
          store.dispatch('FedLogOut').then(() => {
            setTimeout(() => {
              location.reload()
            },500)
          })
        }
        return
      }else if(res.code ==20001){
        setTimeout(() => {
          location.href="/"
        },1000)
      }
      Message({
        message: res.msg,
        type: 'error',
      })
      return Promise.reject(response.data)
    } else {
      return response.data
    }
  },
  error => {
    console.log('err', error);// for debug
    Message({
      message: error.message,
      type: 'error',
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js